$('.confirm-missions-quantity').on('click', function (e) {
    e.preventDefault();

    showPrintSweetAlert();
});

function showPrintSweetAlert() {
    let title = $('.confirm-missions-quantity').data('confirm-missions-quantity') ?? 'mehreren Titel';
    Swal.fire({
        title: 'Warnung',
        icon: 'warning',
        text: 'Anz. der Einsätze muss ausgefüllt werden für Positionen in ' + title + '.',
    });
}
